import React from 'react'

import {
  Icon,
  Notice,
  InfoOutlined,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

const icon = <Icon svgComponent={InfoOutlined} color="primary" />

function PaymentNotice() {
  return (
    <Notice
      type="primary"
      useSSRIcon
      ssrIcon={icon}
    >
      <div className="cgt-ml-10">
        <b>NOTE:</b> Earnings become payable after 20 days following the sale or
        successful completion of a 3D project. Fees for Wildcat projects become
        payable on approval of the delivery. Once you set up your Hyperwallet
        account, payable earnings and fees will be paid weekly on every
        Wednesday or the next business day if Wednesday happens not to be a
        business day.
      </div>
    </Notice>
  )
}

export default PaymentNotice
